import _ from 'lodash';

export default {
  getProjectBaselines: state => projectId => state.projectBaselines[projectId] || [],

  getActiveBaselineData: state => projectId => {
    const enabledBaseline = state.enabledBaselines[projectId];

    if (!enabledBaseline) {
      return null;
    }

    const eventId = enabledBaseline.event_id;
    const baselineData = state.projectBaselineData[projectId]?.[eventId];

    if (!baselineData) {
      return null;
    }

    return baselineData;
  },

  getActiveBaselineUserCustomValues: (state, getters) => (projectId, columnId, taskId) => {
    const baselineData = getters.getActiveBaselineData(projectId);

    if (!baselineData || !baselineData.userCustomColumnsData) {
      return null;
    }

    let result = baselineData.userCustomColumnsData.values;

    if (taskId) {
      result = result[taskId];
    }

    if (columnId) {
      result = _.filter(result, o => o.column_id === +columnId);
    }

    return result;
  },

  getActiveBaselineUserCustomValuesMap: (state, getters) => projectId => {
    const baselineData = getters.getActiveBaselineData(projectId);
    const valuesMap = {};

    if (!baselineData || !baselineData.userCustomColumnsData) {
      return valuesMap;
    }

    Object.keys(baselineData.userCustomColumnsData.values).forEach(taskId => {
      const customColumnValues = baselineData.userCustomColumnsData.values[taskId];

      customColumnValues.forEach(customColumnValueObject => {
        valuesMap[`${taskId}-${customColumnValueObject.column_id}`] = customColumnValueObject.task_value;
      });
    });

    return valuesMap;
  },
};
